import React, { useState } from 'react';
import { useParams , Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

import AdvertisingBook from './AdvertisingBook.jsx';

const BookReader = ({ books }) => {

  const { name } = useParams();
  const book = books.find(b => b.name === name);
  const [isOpen, setIsOpen] = useState(false);


  const toggleDescription = () => {
    setIsOpen(!isOpen);
  };

  if (!book) {
    return <div>Book not found</div>;
  }

  return (
  <>
    <Helmet>
          <title>{book.title}</title>
          <meta name="description" content={book.description}/>
    </Helmet>
    <div className="book-reader">
      <div className="reader-controls">
        <Link to="/"><button style={{height: '60px', width: '60px', background: 'grey'}}> Назад</button></Link>
        
        <h3>{book.author}: {book.title}</h3>

        <button onClick={()=>toggleDescription()} style={{height: '60px', width: '100px', background: 'grey'}}>
          {isOpen ? 'Закрыть описание' : 'Открыть описание'}
        </button>
      </div>


      {isOpen && (
        <div 
          style={{
            marginTop: '10px',
            padding: '15px',
            backgroundColor: '#f9f9f9',
            border: '1px solid #ddd',
            borderRadius: '4px'
          }}
        >
          <p>{book.description}</p>
          <button 
            onClick={toggleDescription}
            style={{
              padding: '5px 10px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer',
              marginTop: '10px'
            }}
          >
            X
          </button>
        </div>
      )}
   
      
      <div className="pdf-container">
        <iframe 
          title={book.title}
          src={book.url}
          width="100%"
          height="600px"
        >
          This browser does not support PDFs. Please download the PDF to view it.
        </iframe>
      </div>
      <div className="advertising-book">
        <AdvertisingBook/>
      </div>
    </div>
    
  </>
  );
};

export default BookReader;